export default __webpack_public_path__ + "static/media/home_bg.pngw3.ebb21b59.webp";